var React = require('react');

function RideTracking (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.921 4.16a2.607 2.607 0 000 3.687L7.764 9.69l1.844-1.844A2.607 2.607 0 105.921 4.16zm3.258 3.258a2 2 0 11-2.829-2.83 2 2 0 012.829 2.83z","key":0}),React.createElement("circle",{"cx":"7.765","cy":"6.003","r":"1.419","key":1}),React.createElement("path",{"d":"M7.764 10.235l-.402-.403v1.21H.818V2.045h6.543v.997c.133-.018.267-.03.403-.03.14 0 .279.013.415.032V.818A.818.818 0 007.361 0H.818A.818.818 0 000 .818v11.451c0 .452.366.818.818.818h6.543a.818.818 0 00.818-.818V9.82l-.415.415zM5.865.807a.204.204 0 110 .407.204.204 0 010-.407zM3.188.818h1.803a.204.204 0 110 .409H3.188a.204.204 0 110-.409zm.902 11.86a.614.614 0 110-1.228.614.614 0 010 1.228z","key":2})]);
}

RideTracking.defaultProps = {"width":"10.372","height":"13.087","viewBox":"0 0 10.372 13.087"};

module.exports = RideTracking;

RideTracking.default = RideTracking;
